import { render, staticRenderFns } from "./VideoControls.vue?vue&type=template&id=cf7c53f2"
import script from "./VideoControls.vue?vue&type=script&lang=js"
export * from "./VideoControls.vue?vue&type=script&lang=js"
import style0 from "./VideoControls.vue?vue&type=style&index=0&id=cf7c53f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports